import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const usePDPRedirectDoubleQuery = () => {
  const $ = _c(4);
  const {
    pathname,
    search: queryParamsString
  } = useLocation();
  let t0;
  let t1;
  if ($[0] !== pathname || $[1] !== queryParamsString) {
    t0 = () => {
      if (queryParamsString) {
        const queryParamsStringWithoutFirstQuestionMark = queryParamsString.replace("?", "");
        if (queryParamsStringWithoutFirstQuestionMark.includes("?")) {
          const updatedQueryParamsString = queryParamsStringWithoutFirstQuestionMark.replace("?", "&");
          window.location.href = `${pathname}?${updatedQueryParamsString}`;
        }
      }
    };
    t1 = [pathname, queryParamsString];
    $[0] = pathname;
    $[1] = queryParamsString;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};
export default usePDPRedirectDoubleQuery;